import './Spinner.css';
import React from 'react';
import { Spinner as Loader } from 'react-bootstrap';
import es from '../../../lang/es';

const Spinner = ({ children, active }) => {
  return (
    <React.Fragment>
      {active && (
        <div data-cy="spinner" className="overlay">
          <Loader
            className="spinner"
            variant="light"
            animation="border"
            role="status"
          >
            <span className="sr-only">{ es.LOADING }...</span>
          </Loader>
        </div>
      )}
      {children}
    </React.Fragment>
  );
};

export default Spinner;